// orientation codes explained
// https://stackoverflow.com/questions/20600800/js-client-side-exif-orientation-rotate-and-mirror-jpeg-images
const ORIENTATION_TYPE_1 = 1;

const hasExifOrientation = (orientation) =>
  Boolean(orientation) && orientation !== ORIENTATION_TYPE_1;

export default hasExifOrientation;
